import { render, staticRenderFns } from "./FooterPdf.vue?vue&type=template&id=0b3a5d7d&scoped=true&"
import script from "./FooterPdf.vue?vue&type=script&lang=js&"
export * from "./FooterPdf.vue?vue&type=script&lang=js&"
import style0 from "./FooterPdf.vue?vue&type=style&index=0&id=0b3a5d7d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3a5d7d",
  null
  
)

export default component.exports